import { ACTION_TYPE } from '../actions/actionTypes';

const ctaReducer = (state = [], action) => {
  switch (action.type) {
    case ACTION_TYPE.SUBMIT_APPOINTMENT_PENDING:
      return {
        ...state,
        submitAppointmentPending: true,
        submitAppointmentSuccess: false,
        submitAppointmentFailure: false,
      };
    case ACTION_TYPE.SUBMIT_APPOINTMENT_SUCCESS:
      return {
        ...state,
        submitAppointmentPending: false,
        submitAppointmentSuccess: true,
        submitAppointmentFailure: false,
      };
    case ACTION_TYPE.SUBMIT_APPOINTMENT_FAILURE:
      return {
        ...state,
        submitAppointmentPending: false,
        submitAppointmentSuccess: false,
        submitAppointmentFailure: true,
        submitAppointmentError: action.payload,
      };
    case ACTION_TYPE.SEND_EMAIL_SUCCESS:
      return {
        ...state,
        referenceCode: action.payload,
      };
    case ACTION_TYPE.ASSET_ALLOC_REF_CODE_SUCCESS:
      return {
        ...state,
        referenceCode: action.payload,
      }
    case ACTION_TYPE.ASSET_ALLOC_REF_CODE_FAIL:
      return {
        ...state,
        referenceCode: null,
        error: action.payload,
      }
    default:
      return state;
  }
};

export default ctaReducer;
